import React from 'react';
import { Link, usePage } from '@inertiajs/react';
import Logo from './Logo';
import { Button } from './ui/button';

export default function Navigation() {
  const { current_user } = usePage().props;
  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="flex-shrink-0 flex items-center">
              <Logo size="default" />
            </div>
            <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
              <Link
                href="/search?care_type=assisted_living"
                className="border-primary text-foreground inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
              >
                Assisted Living
              </Link>
              <Link
                href="/search?care_type=memory_care"
                className="border-transparent text-muted-foreground hover:text-foreground hover:border-gray-300 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
              >
                Memory Care
              </Link>
              <Link
                href="/search"
                className="border-transparent text-muted-foreground hover:text-foreground hover:border-gray-300 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
              >
                All Communities
              </Link>
            </div>
          </div>
          <div className="hidden sm:ml-6 sm:flex sm:items-center">
            <div className="ml-3 relative">
              <div className="flex items-center space-x-4">
                {current_user ? (
                  <>
                    <span className="text-sm text-foreground">
                      {current_user.email}
                    </span>
                    
                    {/* Dashboard links based on user role */}
                    {current_user.role === 'super_admin' && (
                      <Link
                        href="/admin/dashboard"
                        className="text-sm font-medium text-primary hover:text-primary/80"
                      >
                        Admin Dashboard
                      </Link>
                    )}
                    
                    {current_user.role === 'facility_owner' && (
                      <Link
                        href="/facility_owner/dashboard"
                        className="text-sm font-medium text-primary hover:text-primary/80"
                      >
                        Facility Dashboard
                      </Link>
                    )}
                    
                    {current_user.role === 'consumer' && (
                      <Link
                        href="/consumer/dashboard"
                        className="text-sm font-medium text-primary hover:text-primary/80"
                      >
                        My Dashboard
                      </Link>
                    )}
                    
                    {/* Common links for all authenticated users */}
                    <Link
                      href="/conversations"
                      className="text-sm font-medium text-primary hover:text-primary/80"
                    >
                      Messages
                    </Link>
                    <Link
                      href="/sessions"
                      className="text-sm font-medium text-primary hover:text-primary/80"
                    >
                      Account
                    </Link>
                    <Link
                      href="/sessions/1"
                      method="delete"
                      as="button"
                      className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition ease-in-out duration-150"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                      </svg>
                      Sign Out
                    </Link>
                  </>
                ) : (
                  <>
                    <Link
                      href="/sign_in"
                      className="text-sm font-medium text-primary hover:text-primary/80"
                    >
                      Sign In
                    </Link>
                    <Button asChild size="sm">
                      <Link href="/sign_up">
                        Sign Up
                      </Link>
                    </Button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

